import React from "react";
import Modal from "react-modal";
import { SX_dashboard_UI_icon, SX_dashboard_UI_modal } from "../assets/icons";

Modal.setAppElement("#root");

export default function UI_Modal_Clone({
  isOpen,
  children,
  closeModal,
  title,
  styleTop,
  styleLeft,
  styleUnit,
}) {
  let styleModel = {
    content: {
      position: "fixed",
      top: "50%",
      left: "50%",
      transform: "translate(-50%, -50%)",
      // backgroundImage:"var(--shadeblacklinear)",
      height: title === "Forgot Password" ? "400px" : "30%",
      width: title === "Forgot Password" ? "650px" : "27%",
      maxWidth: "75%",
      maxHeight: "75%",
      borderRadius: "1rem",
      outline: "1px solid #ffffffcc",
      padding: "10px",
      overflow: "auto",
    },
    overlay: { backgroundColor: "#1111138c", backdropFilter: "blur(8px)" },
  };
  if (styleTop) {
    styleModel.content.top = styleTop + (styleUnit || "%");
  }
  if (styleLeft) {
    styleModel.content.left = styleLeft + (styleUnit || "%");
  }

  return (
    <Modal
      isOpen={isOpen}
      // onRequestClose={closeModal}
      style={styleModel}
      className="user_input_modal UI_model_project_resp drop-shadow-2xl flex justify-center items-center UI_modal_project"
    >
      {/* <div className="w-1/2 flex justify-center items-center p-[15px]">
        <img
          className="w-[90%] scale-[1.1] ml-[10px] rounded-2xl"
          src={SX_dashboard_UI_modal}
          alt=""
        />
      </div> */}
      <div className="rounded w-full px-4">
        <div
          className="pb-2 flex justify-center items-center text-white "
          style={{
            position: "sticky",
            top: 0,
            zIndex: 1,
            // backgroundColor: "--midnight-navy-100",
          }}
        >
          {" "}
          <div className="pr-2">
            <img className="w-12" src={SX_dashboard_UI_icon} alt="" />
          </div>
          <div className="pl-2 flex flex-col justify-start">
            <span className="manrope-600 text-3xl text-left text-white">
              {title}
            </span>

            {/* Hide paragraph if the title is "Forgot Password" */}
            {/* {title !== "Forgot Password" ? (
              <p className="manrope-400 text-[14px] pb-2 text-center text-white ">
                Project names can be changed anytime.
              </p>
            ) : (
              <p
                className="manrope-400 text-[16px] text-left text-white hello"
                style={{ display: "none" }}
              >
                Project names can be changed anytime.
              </p>
            )} */}
          </div>
        </div>
        <div>{children}</div>
      </div>
    </Modal>
  );
}
